import { qs, on } from '../lib/dom.js';
import { t } from '../lib/i18n.js';

export function initTradeinPage() {
  const form = qs('[data-component="tradein-form"]');
  if (!form) return;
  on(form, 'submit', (e) => {
    e.preventDefault();
    form.querySelector('button[type="submit"]').textContent = t('request_sent', 'Cerere trimisă ✓');
  });
}
